<template>
  <div>
    <table
      v-intersect.once
      class="youtube-list__table">
      <thead class="youtube-list__thead">
        <tr>
          <th class="youtube-list__cell-thumbnail"></th>
          <th class="youtube-list__cell-title">動画タイトル</th>
          <th class="youtube-list__cell-date">申し立て日</th>
          <th class="youtube-list__cell-asset">アセット(作成日)</th>
          <th class="youtube-list__cell-select"></th>
        </tr>
      </thead>
      <tbody
        v-if="items && items.length > 0"
        class="youtube-list__tbody">
        <tr
          v-for="item in items"
          :key="item.id">
          <td>
            <img
              v-if="item.thumbnailUrl"
              :src="item.thumbnailUrl"
              alt="">
            <div
              v-else
              style="margin: 0 auto; background-color: lightgrey; width: 120px; height: 90px;">
            </div>
          </td>
          <td style="text-align: left;vertical-align: top;">
            <div class="video-id">{{ item.videoId }}</div>
            <div>{{ item.title }}</div>
            <div
              v-if="item.channelTitle"
              class="channel-title">
              {{ item.channelTitle }}
            </div>
          </td>
          <td>{{ moment(item.publishedAt).format('YYYY/MM/DD') }}</td>
          <td>
            {{ item.asset.metadata.title }}
            ({{ moment(item.asset.timeCreated).format('YYYY/MM/DD') }})
          </td>
          <td>
            <a
              href="#"
              class="c-btn c-btn--small"
              style="min-width: 160px;"
              @click.prevent="onRowClicked(item.videoId)">
              詳細
            </a>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>

import moment from 'moment/moment'

export default {
  name: 'YouTubeClaimsClaimTable',
  props: {
    items: {
      type: Array,
      required: true,
      default: () => [],
    },
  },
  computed: {
    moment() {
      return moment
    },
  },
  methods: {
    onRowClicked(id) {
      this.$emit('row-clicked', id)
    },
  },
}
</script>

<style scoped>
.channel-title {
  font-size: 12px;
  background-color: grey;
  color: white;
  display: inline;
  padding: 2px 4px;
  border-radius: 3px;
}
.video-id {
  font-size: 12px;
  color: black;
  font-weight: bold;
}
</style>
